import * as i2 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { forwardRef, EventEmitter, PLATFORM_ID, booleanAttribute, numberAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, Output, ViewChild, ContentChildren, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from 'primeng/api';
import { PrimeTemplate, SharedModule } from 'primeng/api';
import * as i4 from 'primeng/autofocus';
import { AutoFocusModule } from 'primeng/autofocus';
import { DomHandler } from 'primeng/dom';
import { TimesIcon } from 'primeng/icons/times';
import * as i3 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';

/*
    Port of jQuery MaskedInput by DigitalBush as a Native Angular2 Component in Typescript without jQuery
    https://github.com/digitalBush/jquery.maskedinput/

    Copyright (c) 2007-2014 Josh Bush (digitalbush.com)

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.
*/
const _c0 = ["input"];
function InputMask_input_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 4, 0);
    i0.ɵɵlistener("focus", function InputMask_input_0_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputFocus($event));
    })("blur", function InputMask_input_0_Template_input_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputBlur($event));
    })("keydown", function InputMask_input_0_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputKeydown($event));
    })("keypress", function InputMask_input_0_Template_input_keypress_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeyPress($event));
    })("input", function InputMask_input_0_Template_input_input_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputChange($event));
    })("paste", function InputMask_input_0_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleInputChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", ctx_r1.inputClass)("ngStyle", ctx_r1.style)("disabled", ctx_r1.disabled)("readonly", ctx_r1.readonly)("variant", ctx_r1.variant)("autofocus", ctx_r1.autofocus);
    i0.ɵɵattribute("id", ctx_r1.inputId)("type", ctx_r1.type)("name", ctx_r1.name)("placeholder", ctx_r1.placeholder)("title", ctx_r1.title)("size", ctx_r1.size)("autocomplete", ctx_r1.autocomplete)("maxlength", ctx_r1.maxlength)("tabindex", ctx_r1.tabindex)("aria-label", ctx_r1.ariaLabel)("aria-required", ctx_r1.ariaRequired)("required", ctx_r1.required)("data-pc-name", "inputmask")("data-pc-section", "root");
  }
}
function InputMask_input_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 5, 0);
    i0.ɵɵlistener("focus", function InputMask_input_1_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputFocus($event));
    })("blur", function InputMask_input_1_Template_input_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputBlur($event));
    })("keydown", function InputMask_input_1_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputKeydown($event));
    })("keypress", function InputMask_input_1_Template_input_keypress_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeyPress($event));
    })("input", function InputMask_input_1_Template_input_input_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInputChange($event));
    })("paste", function InputMask_input_1_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleInputChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r1.style)("ngClass", ctx_r1.styleClass)("disabled", ctx_r1.disabled)("readonly", ctx_r1.readonly)("autofocus", ctx_r1.autoFocus);
    i0.ɵɵattribute("id", ctx_r1.inputId)("type", ctx_r1.type)("name", ctx_r1.name)("placeholder", ctx_r1.placeholder)("title", ctx_r1.title)("size", ctx_r1.size)("autocomplete", ctx_r1.autocomplete)("maxlength", ctx_r1.maxlength)("tabindex", ctx_r1.tabindex)("aria-label", ctx_r1.ariaLabel);
  }
}
function InputMask_ng_container_2_TimesIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "TimesIcon", 8);
    i0.ɵɵlistener("click", function InputMask_ng_container_2_TimesIcon_1_Template_TimesIcon_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clear());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-inputmask-clear-icon");
    i0.ɵɵattribute("data-pc-section", "clearIcon");
  }
}
function InputMask_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function InputMask_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InputMask_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function InputMask_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵlistener("click", function InputMask_ng_container_2_span_2_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clear());
    });
    i0.ɵɵtemplate(1, InputMask_ng_container_2_span_2_1_Template, 1, 0, null, 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "clearIcon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.clearIconTemplate);
  }
}
function InputMask_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, InputMask_ng_container_2_TimesIcon_1_Template, 1, 2, "TimesIcon", 6)(2, InputMask_ng_container_2_span_2_Template, 2, 2, "span", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.clearIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.clearIconTemplate);
  }
}
const INPUTMASK_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputMask),
  multi: true
};
/**
 * InputMask component is used to enter input in a certain format such as numeric, date, currency, email and phone.
 * @group Components
 */
let InputMask = /*#__PURE__*/(() => {
  class InputMask {
    document;
    platformId;
    el;
    cd;
    config;
    /**
     * HTML5 input type.
     * @group Props
     */
    type = 'text';
    /**
     * Placeholder character in mask, default is underscore.
     * @group Props
     */
    slotChar = '_';
    /**
     * Clears the incomplete value on blur.
     * @group Props
     */
    autoClear = true;
    /**
     * When enabled, a clear icon is displayed to clear the value.
     * @group Props
     */
    showClear = false;
    /**
     * Inline style of the input field.
     * @group Props
     */
    style;
    /**
     * Identifier of the focus input to match a label defined for the component.
     * @group Props
     */
    inputId;
    /**
     * Style class of the input field.
     * @group Props
     */
    styleClass;
    /**
     * Advisory information to display on input.
     * @group Props
     */
    placeholder;
    /**
     * Size of the input field.
     * @group Props
     */
    size;
    /**
     * Maximum number of character allows in the input field.
     * @group Props
     */
    maxlength;
    /**
     * Specifies tab order of the element.
     * @group Props
     */
    tabindex;
    /**
     * Title text of the input text.
     * @group Props
     */
    title;
    /**
     * Specifies the input variant of the component.
     * @group Props
     */
    variant = 'outlined';
    /**
     * Used to define a string that labels the input element.
     * @group Props
     */
    ariaLabel;
    /**
     * Used to indicate that user input is required on an element before a form can be submitted.
     * @group Props
     */
    ariaRequired;
    /**
     * When present, it specifies that the element value cannot be altered.
     * @group Props
     */
    disabled;
    /**
     * When present, it specifies that an input field is read-only.
     * @group Props
     */
    readonly;
    /**
     * Defines if ngModel sets the raw unmasked value to bound value or the formatted mask value.
     * @group Props
     */
    unmask;
    /**
     * Name of the input field.
     * @group Props
     */
    name;
    /**
     * When present, it specifies that an input field must be filled out before submitting the form.
     * @group Props
     */
    required;
    /**
     * Regex pattern for alpha characters
     * @group Props
     */
    characterPattern = '[A-Za-z]';
    /**
     * When present, the input gets a focus automatically on load.
     * @group Props
     */
    autofocus;
    /**
     * When present, the input gets a focus automatically on load.
     * @group Props
     * @deprecated Use autofocus property instead.
     */
    set autoFocus(value) {
      this.autofocus = value;
      console.warn('autoFocus is deprecated. Use autofocus property instead.');
    }
    /**
     * Used to define a string that autocomplete attribute the current element.
     * @group Props
     */
    autocomplete;
    /**
     * When present, it specifies that whether to clean buffer value from model.
     * @group Props
     */
    keepBuffer = false;
    /**
     * Mask pattern.
     * @group Props
     */
    get mask() {
      return this._mask;
    }
    set mask(val) {
      this._mask = val;
      this.initMask();
      this.writeValue('');
      this.onModelChange(this.value);
    }
    /**
     * Callback to invoke when the mask is completed.
     * @group Emits
     */
    onComplete = new EventEmitter();
    /**
     * Callback to invoke when the component receives focus.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onFocus = new EventEmitter();
    /**
     * Callback to invoke when the component loses focus.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onBlur = new EventEmitter();
    /**
     * Callback to invoke on input.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onInput = new EventEmitter();
    /**
     * Callback to invoke on input key press.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onKeydown = new EventEmitter();
    /**
     * Callback to invoke when input field is cleared.
     * @group Emits
     */
    onClear = new EventEmitter();
    inputViewChild;
    templates;
    clearIconTemplate;
    value;
    _mask;
    onModelChange = () => {};
    onModelTouched = () => {};
    input;
    filled;
    defs;
    tests;
    partialPosition;
    firstNonMaskPos;
    lastRequiredNonMaskPos;
    len;
    oldVal;
    buffer;
    defaultBuffer;
    focusText;
    caretTimeoutId;
    androidChrome = true;
    focused;
    _variant = 'outlined';
    get inputClass() {
      return {
        'p-inputmask': true
      };
    }
    constructor(document, platformId, el, cd, config) {
      this.document = document;
      this.platformId = platformId;
      this.el = el;
      this.cd = cd;
      this.config = config;
    }
    ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
        let ua = navigator.userAgent;
        this.androidChrome = /chrome/i.test(ua) && /android/i.test(ua);
      }
      this.initMask();
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'clearicon':
            this.clearIconTemplate = item.template;
            break;
        }
      });
    }
    initMask() {
      this.tests = [];
      this.partialPosition = this.mask.length;
      this.len = this.mask.length;
      this.firstNonMaskPos = null;
      this.defs = {
        '9': '[0-9]',
        a: this.characterPattern,
        '*': `${this.characterPattern}|[0-9]`
      };
      let maskTokens = this.mask.split('');
      for (let i = 0; i < maskTokens.length; i++) {
        let c = maskTokens[i];
        if (c == '?') {
          this.len--;
          this.partialPosition = i;
        } else if (this.defs[c]) {
          this.tests.push(new RegExp(this.defs[c]));
          if (this.firstNonMaskPos === null) {
            this.firstNonMaskPos = this.tests.length - 1;
          }
          if (i < this.partialPosition) {
            this.lastRequiredNonMaskPos = this.tests.length - 1;
          }
        } else {
          this.tests.push(null);
        }
      }
      this.buffer = [];
      for (let i = 0; i < maskTokens.length; i++) {
        let c = maskTokens[i];
        if (c != '?') {
          if (this.defs[c]) this.buffer.push(this.getPlaceholder(i));else this.buffer.push(c);
        }
      }
      this.defaultBuffer = this.buffer.join('');
    }
    writeValue(value) {
      this.value = value;
      if (this.inputViewChild && this.inputViewChild.nativeElement) {
        if (this.value == undefined || this.value == null) this.inputViewChild.nativeElement.value = '';else this.inputViewChild.nativeElement.value = this.value;
        this.checkVal();
        this.focusText = this.inputViewChild.nativeElement.value;
        this.updateFilledState();
      }
    }
    registerOnChange(fn) {
      this.onModelChange = fn;
    }
    registerOnTouched(fn) {
      this.onModelTouched = fn;
    }
    setDisabledState(val) {
      this.disabled = val;
      this.cd.markForCheck();
    }
    caret(first, last) {
      let range, begin, end;
      if (!this.inputViewChild?.nativeElement.offsetParent || this.inputViewChild.nativeElement !== this.inputViewChild.nativeElement.ownerDocument.activeElement) {
        return;
      }
      if (typeof first == 'number') {
        begin = first;
        end = typeof last === 'number' ? last : begin;
        if (this.inputViewChild.nativeElement.setSelectionRange) {
          this.inputViewChild.nativeElement.setSelectionRange(begin, end);
        } else if (this.inputViewChild.nativeElement['createTextRange']) {
          range = this.inputViewChild.nativeElement['createTextRange']();
          range.collapse(true);
          range.moveEnd('character', end);
          range.moveStart('character', begin);
          range.select();
        }
      } else {
        if (this.inputViewChild.nativeElement.setSelectionRange) {
          begin = this.inputViewChild.nativeElement.selectionStart;
          end = this.inputViewChild.nativeElement.selectionEnd;
        } else if (this.document && this.document['selection'].createRange) {
          range = this.document.createRange();
          begin = 0 - range.duplicate().moveStart('character', -100000);
          end = begin + range.text.length;
        }
        return {
          begin: begin,
          end: end
        };
      }
    }
    isCompleted() {
      let completed;
      for (let i = this.firstNonMaskPos; i <= this.lastRequiredNonMaskPos; i++) {
        if (this.tests[i] && this.buffer[i] === this.getPlaceholder(i)) {
          return false;
        }
      }
      return true;
    }
    getPlaceholder(i) {
      if (i < this.slotChar.length) {
        return this.slotChar.charAt(i);
      }
      return this.slotChar.charAt(0);
    }
    seekNext(pos) {
      while (++pos < this.len && !this.tests[pos]);
      return pos;
    }
    seekPrev(pos) {
      while (--pos >= 0 && !this.tests[pos]);
      return pos;
    }
    shiftL(begin, end) {
      let i, j;
      if (begin < 0) {
        return;
      }
      for (i = begin, j = this.seekNext(end); i < this.len; i++) {
        if (this.tests[i]) {
          if (j < this.len && this.tests[i].test(this.buffer[j])) {
            this.buffer[i] = this.buffer[j];
            this.buffer[j] = this.getPlaceholder(j);
          } else {
            break;
          }
          j = this.seekNext(j);
        }
      }
      this.writeBuffer();
      this.caret(Math.max(this.firstNonMaskPos, begin));
    }
    shiftR(pos) {
      let i, c, j, t;
      for (i = pos, c = this.getPlaceholder(pos); i < this.len; i++) {
        if (this.tests[i]) {
          j = this.seekNext(i);
          t = this.buffer[i];
          this.buffer[i] = c;
          if (j < this.len && this.tests[j].test(t)) {
            c = t;
          } else {
            break;
          }
        }
      }
    }
    handleAndroidInput(e) {
      var curVal = this.inputViewChild?.nativeElement.value;
      var pos = this.caret();
      if (this.oldVal && this.oldVal.length && this.oldVal.length > curVal.length) {
        // a deletion or backspace happened
        this.checkVal(true);
        while (pos.begin > 0 && !this.tests[pos.begin - 1]) pos.begin--;
        if (pos.begin === 0) {
          while (pos.begin < this.firstNonMaskPos && !this.tests[pos.begin]) pos.begin++;
        }
        setTimeout(() => {
          this.caret(pos.begin, pos.begin);
          this.updateModel(e);
          if (this.isCompleted()) {
            this.onComplete.emit();
          }
        }, 0);
      } else {
        this.checkVal(true);
        while (pos.begin < this.len && !this.tests[pos.begin]) pos.begin++;
        setTimeout(() => {
          this.caret(pos.begin, pos.begin);
          this.updateModel(e);
          if (this.isCompleted()) {
            this.onComplete.emit();
          }
        }, 0);
      }
    }
    onInputBlur(e) {
      this.focused = false;
      this.onModelTouched();
      if (!this.keepBuffer) {
        this.checkVal();
      }
      this.updateFilledState();
      this.onBlur.emit(e);
      if (this.inputViewChild?.nativeElement.value != this.focusText || this.inputViewChild?.nativeElement.value != this.value) {
        this.updateModel(e);
        let event = this.document.createEvent('HTMLEvents');
        event.initEvent('change', true, false);
        this.inputViewChild?.nativeElement.dispatchEvent(event);
      }
    }
    onInputKeydown(e) {
      if (this.readonly) {
        return;
      }
      let k = e.which || e.keyCode,
        pos,
        begin,
        end;
      let iPhone;
      if (isPlatformBrowser(this.platformId)) {
        iPhone = /iphone/i.test(DomHandler.getUserAgent());
      }
      this.oldVal = this.inputViewChild?.nativeElement.value;
      this.onKeydown.emit(e);
      //backspace, delete, and escape get special treatment
      if (k === 8 || k === 46 || iPhone && k === 127) {
        pos = this.caret();
        begin = pos.begin;
        end = pos.end;
        if (end - begin === 0) {
          begin = k !== 46 ? this.seekPrev(begin) : end = this.seekNext(begin - 1);
          end = k === 46 ? this.seekNext(end) : end;
        }
        this.clearBuffer(begin, end);
        if (this.keepBuffer) {
          this.shiftL(begin, end - 2);
        } else {
          this.shiftL(begin, end - 1);
        }
        this.updateModel(e);
        this.onInput.emit(e);
        e.preventDefault();
      } else if (k === 13) {
        // enter
        this.onInputBlur(e);
        this.updateModel(e);
      } else if (k === 27) {
        // escape
        this.inputViewChild.nativeElement.value = this.focusText;
        this.caret(0, this.checkVal());
        this.updateModel(e);
        e.preventDefault();
      }
    }
    onKeyPress(e) {
      if (this.readonly) {
        return;
      }
      var k = e.which || e.keyCode,
        pos = this.caret(),
        p,
        c,
        next,
        completed;
      if (e.ctrlKey || e.altKey || e.metaKey || k < 32 || k > 34 && k < 41) {
        //Ignore
        return;
      } else if (k && k !== 13) {
        if (pos.end - pos.begin !== 0) {
          this.clearBuffer(pos.begin, pos.end);
          this.shiftL(pos.begin, pos.end - 1);
        }
        p = this.seekNext(pos.begin - 1);
        if (p < this.len) {
          c = String.fromCharCode(k);
          if (this.tests[p].test(c)) {
            this.shiftR(p);
            this.buffer[p] = c;
            this.writeBuffer();
            next = this.seekNext(p);
            if (DomHandler.isClient() && /android/i.test(DomHandler.getUserAgent())) {
              let proxy = () => {
                this.caret(next);
              };
              setTimeout(proxy, 0);
            } else {
              this.caret(next);
            }
            if (pos.begin <= this.lastRequiredNonMaskPos) {
              completed = this.isCompleted();
            }
            this.onInput.emit(e);
          }
        }
        e.preventDefault();
      }
      this.updateModel(e);
      this.updateFilledState();
      if (completed) {
        this.onComplete.emit();
      }
    }
    clearBuffer(start, end) {
      if (!this.keepBuffer) {
        let i;
        for (i = start; i < end && i < this.len; i++) {
          if (this.tests[i]) {
            this.buffer[i] = this.getPlaceholder(i);
          }
        }
      }
    }
    writeBuffer() {
      this.inputViewChild.nativeElement.value = this.buffer.join('');
    }
    checkVal(allow) {
      //try to place characters where they belong
      let test = this.inputViewChild?.nativeElement.value,
        lastMatch = -1,
        i,
        c,
        pos;
      for (i = 0, pos = 0; i < this.len; i++) {
        if (this.tests[i]) {
          this.buffer[i] = this.getPlaceholder(i);
          while (pos++ < test.length) {
            c = test.charAt(pos - 1);
            if (this.tests[i].test(c)) {
              if (!this.keepBuffer) {
                this.buffer[i] = c;
              }
              lastMatch = i;
              break;
            }
          }
          if (pos > test.length) {
            this.clearBuffer(i + 1, this.len);
            break;
          }
        } else {
          if (this.buffer[i] === test.charAt(pos)) {
            pos++;
          }
          if (i < this.partialPosition) {
            lastMatch = i;
          }
        }
      }
      if (allow) {
        this.writeBuffer();
      } else if (lastMatch + 1 < this.partialPosition) {
        if (this.autoClear || this.buffer.join('') === this.defaultBuffer) {
          // Invalid value. Remove it and replace it with the
          // mask, which is the default behavior.
          if (this.inputViewChild?.nativeElement.value) this.inputViewChild.nativeElement.value = '';
          this.clearBuffer(0, this.len);
        } else {
          // Invalid value, but we opt to show the value to the
          // user and allow them to correct their mistake.
          this.writeBuffer();
        }
      } else {
        this.writeBuffer();
        this.inputViewChild.nativeElement.value = this.inputViewChild?.nativeElement.value.substring(0, lastMatch + 1);
      }
      return this.partialPosition ? i : this.firstNonMaskPos;
    }
    onInputFocus(event) {
      if (this.readonly) {
        return;
      }
      this.focused = true;
      clearTimeout(this.caretTimeoutId);
      let pos;
      this.focusText = this.inputViewChild?.nativeElement.value;
      pos = this.keepBuffer ? this.inputViewChild?.nativeElement.value.length : this.checkVal();
      this.caretTimeoutId = setTimeout(() => {
        if (this.inputViewChild?.nativeElement !== this.inputViewChild?.nativeElement.ownerDocument.activeElement) {
          return;
        }
        this.writeBuffer();
        if (pos == this.mask?.replace('?', '').length) {
          this.caret(0, pos);
        } else {
          this.caret(pos);
        }
      }, 10);
      this.onFocus.emit(event);
    }
    onInputChange(event) {
      if (this.androidChrome) this.handleAndroidInput(event);else this.handleInputChange(event);
      this.onInput.emit(event);
    }
    handleInputChange(event) {
      if (this.readonly || this.disabled) {
        return;
      }
      setTimeout(() => {
        var pos = this.checkVal(true);
        this.caret(pos);
        this.updateModel(event);
        if (this.isCompleted()) {
          this.onComplete.emit();
        }
      }, 0);
    }
    getUnmaskedValue() {
      let unmaskedBuffer = [];
      for (let i = 0; i < this.buffer.length; i++) {
        let c = this.buffer[i];
        if (this.tests[i] && c != this.getPlaceholder(i)) {
          unmaskedBuffer.push(c);
        }
      }
      return unmaskedBuffer.join('');
    }
    updateModel(e) {
      const updatedValue = this.unmask ? this.getUnmaskedValue() : e.target.value;
      if (updatedValue !== null || updatedValue !== undefined) {
        this.value = updatedValue;
        this.onModelChange(this.value);
      }
    }
    updateFilledState() {
      this.filled = this.inputViewChild?.nativeElement && this.inputViewChild.nativeElement.value != '';
    }
    focus() {
      this.inputViewChild?.nativeElement.focus();
    }
    clear() {
      this.inputViewChild.nativeElement.value = '';
      this.value = null;
      this.onModelChange(this.value);
      this.onClear.emit();
    }
    static ɵfac = function InputMask_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputMask)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.PrimeNGConfig));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InputMask,
      selectors: [["p-inputMask"]],
      contentQueries: function InputMask_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function InputMask_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputViewChild = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      hostVars: 6,
      hostBindings: function InputMask_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("p-inputwrapper-filled", ctx.filled)("p-inputwrapper-focus", ctx.focused)("p-inputmask-clearable", ctx.showClear && !ctx.disabled);
        }
      },
      inputs: {
        type: "type",
        slotChar: "slotChar",
        autoClear: [2, "autoClear", "autoClear", booleanAttribute],
        showClear: [2, "showClear", "showClear", booleanAttribute],
        style: "style",
        inputId: "inputId",
        styleClass: "styleClass",
        placeholder: "placeholder",
        size: [2, "size", "size", numberAttribute],
        maxlength: [2, "maxlength", "maxlength", numberAttribute],
        tabindex: "tabindex",
        title: "title",
        variant: "variant",
        ariaLabel: "ariaLabel",
        ariaRequired: [2, "ariaRequired", "ariaRequired", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        readonly: [2, "readonly", "readonly", booleanAttribute],
        unmask: [2, "unmask", "unmask", booleanAttribute],
        name: "name",
        required: [2, "required", "required", booleanAttribute],
        characterPattern: "characterPattern",
        autofocus: [2, "autofocus", "autofocus", booleanAttribute],
        autoFocus: [2, "autoFocus", "autoFocus", booleanAttribute],
        autocomplete: "autocomplete",
        keepBuffer: [2, "keepBuffer", "keepBuffer", booleanAttribute],
        mask: "mask"
      },
      outputs: {
        onComplete: "onComplete",
        onFocus: "onFocus",
        onBlur: "onBlur",
        onInput: "onInput",
        onKeydown: "onKeydown",
        onClear: "onClear"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([INPUTMASK_VALUE_ACCESSOR]), i0.ɵɵInputTransformsFeature],
      decls: 3,
      vars: 3,
      consts: [["input", ""], ["pInputText", "", "pAutoFocus", "", 3, "class", "ngClass", "ngStyle", "disabled", "readonly", "variant", "autofocus", "focus", "blur", "keydown", "keypress", "input", "paste", 4, "ngIf"], ["pInputText", "", "class", "p-inputmask", "pAutoFocus", "", 3, "ngStyle", "ngClass", "disabled", "readonly", "autofocus", "focus", "blur", "keydown", "keypress", "input", "paste", 4, "ngIf"], [4, "ngIf"], ["pInputText", "", "pAutoFocus", "", 3, "focus", "blur", "keydown", "keypress", "input", "paste", "ngClass", "ngStyle", "disabled", "readonly", "variant", "autofocus"], ["pInputText", "", "pAutoFocus", "", 1, "p-inputmask", 3, "focus", "blur", "keydown", "keypress", "input", "paste", "ngStyle", "ngClass", "disabled", "readonly", "autofocus"], [3, "styleClass", "click", 4, "ngIf"], ["class", "p-inputmask-clear-icon", 3, "click", 4, "ngIf"], [3, "click", "styleClass"], [1, "p-inputmask-clear-icon", 3, "click"], [4, "ngTemplateOutlet"]],
      template: function InputMask_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, InputMask_input_0_Template, 2, 22, "input", 1)(1, InputMask_input_1_Template, 2, 15, "input", 2)(2, InputMask_ng_container_2_Template, 3, 2, "ng-container", 3);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.required);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.required);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.value != null && ctx.filled && ctx.showClear && !ctx.disabled);
        }
      },
      dependencies: () => [i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, i3.InputText, i4.AutoFocus, TimesIcon],
      styles: [".p-inputmask-clear-icon{position:absolute;top:50%;margin-top:-.5rem;cursor:pointer}.p-inputmask-clearable{position:relative}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return InputMask;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputMaskModule = /*#__PURE__*/(() => {
  class InputMaskModule {
    static ɵfac = function InputMaskModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputMaskModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: InputMaskModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, InputTextModule, AutoFocusModule, TimesIcon, SharedModule]
    });
  }
  return InputMaskModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { INPUTMASK_VALUE_ACCESSOR, InputMask, InputMaskModule };
